<script setup lang="ts">
    import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';

    const localPath = useLocalePathWoom();

    const { fetchCustomer, shopifyAccountUrl } = useAccount();
    const { data } = await fetchCustomer();
</script>
<template>
    <div class="atm-account-button relative h-12 w-12 place-content-center lg:h-10 lg:w-10">
        <woom-icon-profile class="profile-icon m-auto h-6 fill-current transition-colors" />
        <client-only>
            <popover
                v-if="data?.emailAddress?.emailAddress"
                v-slot="{ open, close }">
                <popover-button
                    :class="['absolute inset-0', { 'popover-open': open }]"
                    type="button"
                    :aria-label="$t('cta.account.openDropdown')">
                    <span class="absolute bottom-3 right-3 h-2 w-2 rounded-full bg-woom-green lg:bottom-2 lg:right-2"></span>
                </popover-button>
                <popover-panel
                    class="absolute -right-8 top-[calc(100%+10px)] z-lg rounded-lg bg-woom-white p-4 text-base drop-shadow-lg before:absolute before:-top-4 before:right-8 before:border-[16px] before:border-t-0 before:border-transparent before:border-b-woom-white">
                    <div class="border-b border-woom-grey-mid pb-4">
                        <div class="flex items-center gap-2">
                            <woom-icon-user class="h-6" />
                            <div>
                                <div
                                    v-if="data.firstName"
                                    class="overflow-hidden truncate first:font-bold max-md:max-w-64">
                                    {{ data.displayName }}
                                </div>
                                <div class="overflow-hidden truncate first:font-bold max-md:max-w-64">{{ data.emailAddress.emailAddress }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-1 border-b border-woom-grey-mid py-1">
                        <nuxt-link-locale
                            class="py-2 hover:text-woom-red"
                            to="/account"
                            @click="close">
                            {{ $t('cta.account.account') }}
                        </nuxt-link-locale>
                        <!-- <a
                            :href="shopifyAccountUrl"
                            class="py-2 hover:text-woom-red"
                            target="_blank"
                            @click="close">
                            {{ $t('cta.account.orders') }}
                        </a> -->
                    </div>
                    <a
                        :href="localPath('/logout')"
                        class="flex h-12 items-center hover:text-woom-red"
                        @click="close">
                        <woom-icon-share class="mr-4 h-5 -rotate-90 fill-current" />
                        {{ $t('cta.account.logout') }}
                    </a>
                </popover-panel>
            </popover>

            <a
                v-else
                :href="localPath('/login')"
                :aria-label="$t('cta.account.login')"
                class="absolute inset-0">
            </a>
        </client-only>
    </div>
</template>
<style scoped>
    .atm-account-button:hover .profile-icon,
    .atm-account-button:has(.popover-open) .profile-icon {
        @apply text-woom-red;
    }
</style>
